import script from "./fcPage.vue?vue&type=script&setup=true&lang=js"
export * from "./fcPage.vue?vue&type=script&setup=true&lang=js"

import "./fcPage.vue?vue&type=style&index=0&id=6ed20db9&lang=css"

const __exports__ = script;

export default __exports__